import { Autocomplete, Box, Grid, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, StepConnector, Checkbox, FormControlLabel, FormGroup, InputAdornment, Link, MenuItem, Select, Stack, Step, StepLabel, Stepper, TextField, Tooltip, Typography, useScrollTrigger } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { Visibility, VisibilityOff, InfoOutlined } from "@mui/icons-material";
// import Header from '../../core/Header/Header'
import Header from '../../core/Header/Header'
import './style.css'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { hideLoader, showLoader, setUserDetail } from '../../Store/mainSlice'
import httpClient from '../../_util/api'
import CustomizedSnackbars from '../../shared/Snackbar/SnackBar'
import { UploadImagetoFb } from '../../Hooks/uploadImage'
import dayjs from 'dayjs';
import Desclaimer from './Desclaimer'
import ButtonMain from '../../components/Button';
import FileUpload from '../../components/FileUpload';
import { getRedirectPath } from '../../Helpers/Redirect';
import { setAuthSessionExpiry } from '../../_util/session';
import DocumentInstructionModal from '../../components/DocumentInstructionModal';
import { isLowGpa, LOW_GPA_WARNING_TEXT } from '../../_util/gpa';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// Same PDF as student apply-scholarship — upload document instruction
const INSTRUCTIONS_PDF_URL =
  'https://firebasestorage.googleapis.com/v0/b/al-kauser-b6277.firebasestorage.app/o/products%2FInstructions%20to%20upload%20documents%20on%20the%20Portal.pdf%2Btyweyey%2B1773097686967-999457?alt=media&token=17afd8de-84a4-4616-bf5d-cc8f23c749f6';

const REFERENCE_LETTER_PDF_URL = 
  "https://firebasestorage.googleapis.com/v0/b/al-kauser-b6277.firebasestorage.app/o/products%2FTemplate%20Reference%20Letter%20for%20Scholarship.pdf%2Btyweyey%2B1774389937719-134219?alt=media&token=3315f7f0-90a3-4727-9a03-9f4250ec9172";


const ScholarshipForm = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate()
  const { token: inviteTokenParam } = useParams()
  const [linkStatus, setLinkStatus] = useState('checking') // 'checking' | 'valid' | 'invalid'
  const [linkError, setLinkError] = useState('')
  const dispatch = useDispatch()
  const snackbar_Ref = useRef()
  const transcriptPhotoRef = useRef()
  const voucherPhotoRef = useRef()
  const studentCNICPhotoRef = useRef()
  const studentCNICBackPhotoRef = useRef()
  const parentCNICPhotoRef = useRef()
  const parentCNICBackPhotoRef = useRef()
  const proofOfIncomePicRef = useRef()
  const currentBillPicRef = useRef()
  const additionalDocsRef = useRef()
  const otherDocumentsRef = useRef()
  const referenceletterRef1 = useRef()
  const referenceletterRef2 = useRef()
  const [activeStep, setActiveStep] = useState(-1)
  const [instructionModalOpen, setInstructionModalOpen] = useState(false)
  const [lowGpaDialogOpen, setLowGpaDialogOpen] = useState(false)
  const [countryCode, setCountryCode] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [isChecked, setIsChecked] = useState(false)
  const [isNewStudent, setIsNewStudent] = useState(false)
  const [isReturningStudent, setIsReturningStudent] = useState(false)
  const [universities, setUniversities] = useState([])
  const facultyOptions = [
    "Architecture & Planning",
    "Business Management",
    "Computing & IT",
    "Education",
    "Engineering & Technology",
    "Fashion, Textile & Media Studies",
    "Health & Medical Sciences",
    "LAW",
    "Life Sciences",
    "Science & Technology",
    "Social Sciences",
    "Misc.",
    "Other",
  ];
  const [studentData, setStudentData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    gender: "",
    address: "",
    town: "",
    phoneNo_Mobile: "",
    phoneNo_Home: "",
    CNICNo: "",
    country: "",
    presentHouseholdIncome: 0,
    totalFamilyMembers: 0,
    fatherName: "",
    motherName: "",
    orphan: "",
    signature: "",
    password: "",
    confirmPassword: "",
    faculty: "",
    degree: "",
    enrollmentNo: "",
    otherFaculty: "",
    grade: "",
    institutionName: "",
    otherInstitutionName: "",
    institutionAddress: "",
    tuttionFee: 0,
    classOfLastInstitution: "",
    acknowledgedLowGpa: false,
    requestedAmount: 0,
    description: "",
    referenceName1: "",
    referenceEmail1: "",
    referencePhone1: "",
    referenceName2: "",
    referenceEmail2: "",
    referencePhone2: "",
    additionalDocs: {
      fileName: "",
      url: ""
    },
    otherDocumentsFile: {
      fileName: "",
      url: ""
    },
    resultOfLastExamFile: {
      fileName: "",
      url: ""
    },
    feeVoucherFile: {
      fileName: "",
      url: ""
    },
    CNICFrontFile: {
      fileName: "",
      url: ""
    },
    CNICBackFile: {
      fileName: "",
      url: ""
    },
    parentCNICFrontFile: {
      fileName: "",
      url: ""
    },
    parentCNICBackFile: {
      fileName: "",
      url: ""
    },
    proofOfIncomeFile: {
      fileName: "",
      url: ""
    },
    currentElectricBillFile: {
      fileName: "",
      url: ""
    },
    // additionalDocsPicFileName: "",
    referenceLetterFile1: {
      fileName: "",
      url: ""
    },
    referenceLetterFile2: {
      fileName: "",
      url: ""
    },

    // resultOfLastExamPicURL: "",
    // feeVoucherPicURL: "",
    // CNICPicURL: "",
    // parentCNICPicURL: "",
    // parentCNICBackPicURL: "",
    // proofOfIncomePicURL: "",
    // currentElectricBillURL: "",
    // // additionalDocsPicURL: "",
    // referenceLetterPicURL1: "",
    // referenceLetterPicURL2: "",
    countryCode: "+92",
    inviteToken: ""
  })
  
  const countryCodes = [
    { label: '+1', value: 'US' },
    { label: '+44', value: 'UK' },
    { label: '+92', value: 'Pakistan' },
    { label: '+91', value: 'India' },
  ];

  const saveHandler = async () => {
    dispatch(showLoader())
    console.table("studentData", studentData)
    const res = await httpClient.post('/students/registerStudent', studentData).catch((error) => {
      dispatch(hideLoader())
      snackbar_Ref.current.showMessage("error", error?.response.data.message, "", "i-chk-circle");
    })

    if (res?.status === 200) {
      dispatch(hideLoader())
      snackbar_Ref.current.showMessage("success", res.data.message, "", "i-chk-circle");
      nextHandler()
    }
  }

  const nextHandler = () => {
    if (isChecked) {
      setActiveStep((currentStep) => currentStep + 1);
    }
  }

  const previousHandler = () => {
    setActiveStep((currentStep) => currentStep - 1);
  }

  const handleInputChange = (data, field, fieldType) => {
    const updatedValue = fieldType === 'number' ? parseFloat(data) : data;
    setStudentData((prevFormData) => ({ ...prevFormData, [field]: updatedValue }));
  };

  const uploadPhotoHandler = (refType) => {
    const refCreator = {
      transcriptPhotoRef,
      voucherPhotoRef,
      studentCNICPhotoRef,
      studentCNICBackPhotoRef,
      parentCNICPhotoRef,
      parentCNICBackPhotoRef,
      proofOfIncomePicRef,
      currentBillPicRef,
      additionalDocsRef,
      otherDocumentsRef,
      referenceletterRef1,
      referenceletterRef2,
    }[refType];
  
    if (refCreator) {
      refCreator?.current?.click();
    }
  };
  
  const handleFileChange = async (event, field) => {
    const file = event.target.files[0];
    if (!file) return;
    const fileType = file.type;
    
    if (fileType !== "application/pdf") {
      alert('Please upload a PDF file.');
      return;
    }
    
    const MAX_FILE_SIZE_MB = 1.5;
    
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

    if (file.size > MAX_FILE_SIZE_BYTES) {
      alert(`File size should not exceed ${MAX_FILE_SIZE_MB} MB.`);
      return;
    }

    dispatch(showLoader());
  
    try {
      const newFile = {};
      const uploadedFile = await UploadImagetoFb(event);
  
      newFile.fileName = file.name;
      newFile.url = uploadedFile.url;
  
      if (field === "multiple") {
        if (Array.isArray(studentData.additionalDocs)) {
          setStudentData((prev) => ({
            ...prev,
            [field]: [...prev[field], newFile],
          }));
        }
      } else {
        setStudentData((prev) => ({
          ...prev,
          [field]: newFile,
        }));
      }
    } catch (err) {
      debugger;
      console.error("Upload error:", err);
      alert("File upload failed. Please try again.");
    } finally {
      dispatch(hideLoader());
    }
  };
  

  const handleDateChange = (date, field) => {
    const formattedDate = dayjs(date).format('M/D/YYYY');
    setStudentData((prevFormData) => ({ ...prevFormData, [field]: formattedDate }));
  };

  const addPersonalDetailHandler = async () => {
    dispatch(showLoader());
    try {
      const res = await httpClient.post('/students/addStudentPersonalDetail', studentData);
      if (res?.status === 200) {
        dispatch(hideLoader());
        nextHandler();
      }
    } catch (error) {
      dispatch(hideLoader());
      snackbar_Ref.current.showMessage("error", error?.response?.data?.message, "", "i-chk-circle");
    }
  };
  
  const submitEducationalDetail = async (data) => {
    dispatch(showLoader());
    try {
      const res = await httpClient.post('/students/addStudentEducationalDetail', data);
      if (res?.status === 200) {
        dispatch(hideLoader());
        nextHandler();
      }
    } catch (error) {
      dispatch(hideLoader());
      snackbar_Ref.current.showMessage("error", error?.response?.data?.message || "An error occurred", "", "i-chk-circle");
    }
  };

  const addEducationalDetailHandler = async () => {
    // Low GPA/CGPA warning: a new applicant can only ever hit the first-time
    // warning here — they must acknowledge it before continuing. The flag rides
    // along in studentData and is enforced by the backend at final submit.
    if (isLowGpa(studentData.classOfLastInstitution) && !studentData.acknowledgedLowGpa) {
      setLowGpaDialogOpen(true);
      return;
    }
    submitEducationalDetail(studentData);
  };
  
  const addReferenceDetailHandler = async () => {
    dispatch(showLoader());
    try {
      const res = await httpClient.post('/students/addStudentReferenceDetail', studentData);
  
      if (res?.status === 200) {
        dispatch(hideLoader());
        nextHandler();
      }
    } catch (error) {
      dispatch(hideLoader());
      snackbar_Ref.current.showMessage("error", error?.response?.data?.message || "An error occurred", "", "i-chk-circle");
    }
  };
  
  const addAttachmentDetailHandler = async () => {
    dispatch(showLoader());
    try {
      const res = await httpClient.post('/students/addStudentAttachmentDetail', studentData);
      if (res?.status === 200) {
        const { token, role } = res.data;
        localStorage.setItem('authToken', token);
        setAuthSessionExpiry();
        dispatch(setUserDetail(res.data));
        navigate(getRedirectPath(role));
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      snackbar_Ref.current.showMessage("error", error?.response?.data?.message || "An error occurred", "", "i-chk-circle");
    } finally {
    }
  };
  

  const startFormHandler = async () => {

    if (isReturningStudent && studentData.CNICNo) {
      dispatch(showLoader())

      const res = await httpClient.get(`/students/getStudentByCNIC/${studentData.CNICNo}`).catch((error) => {
        dispatch(hideLoader())
        snackbar_Ref.current.showMessage("error", error?.response.data.message, "", "i-chk-circle");
      })

      if (res?.status == 200) {
        dispatch(hideLoader())
        setStudentData(res.data)
        setActiveStep((currentStep) => currentStep + 1);
      }


    }
    else if (isNewStudent) {
      setActiveStep((currentStep) => currentStep + 1);
    }

  }

  const handleDownloadReferenceLetter = () => {
    const url = REFERENCE_LETTER_PDF_URL.trim();

    if (!url) {
      snackbar_Ref.current?.showMessage(
        "error",
        "Reference letter link is not set.",
        "",
        "i-chk-circle"
      );
      return;
    }

    window.open(url, "_blank", "noopener,noreferrer");
  };
  
  const handleCheckBox = async (event) => {
    setIsChecked(event.target.checked)
  }

  const handleNewStudent = async (event) => {
    setIsReturningStudent(false)
    setIsNewStudent(event.target.checked)

  }

  const handleReturningStudent = async (event) => {
    setIsNewStudent(false)
    setIsReturningStudent(event.target.checked)
  }

  const handleCNICNoChange = (data) => {
    let value = data.replace(/[^0-9]/g, "");
    let formattedValue = "";

    if (value.length > 5) {
      formattedValue += value.substring(0, 5) + "-";
      if (value.length > 12) {
        formattedValue += value.substring(5, 12) + "-";
        formattedValue += value.substring(12, 13);
      }
      else if (value.length > 5) {
        formattedValue += value.substring(5);
      }
    } else {
      formattedValue = value;
    }


    setStudentData((prev) => ({ ...prev, CNICNo: formattedValue }))
  }

  const getAllPakistaniUni = async () => {
    let res = await httpClient.get('students/getAllPakUniversities').catch((error) => {
      console.log("error", error)
    })
    if (res?.status === 200) {
      const universityNames = res.data.map(item => item.name);
      setUniversities(['Other', ...universityNames]);
    }

  }

  const handleAutocompleteValue = (data, field) => {
    setStudentData((prevValue) => ({ ...prevValue, [field]: data }))
  }

  useEffect(() => {
    getAllPakistaniUni();
  }, [])

  // This page is only reachable via a one-time invite link (/scholarshipForm/:token).
  // Validate it before letting anyone see or fill out the form.
  useEffect(() => {
    const validateInviteLink = async () => {
      if (!inviteTokenParam) {
        setLinkStatus('invalid');
        setLinkError('This application link is incomplete. Please use the exact link you were sent to apply.');
        return;
      }
      try {
        await httpClient.get(`/students/validateScholarshipInvite/${inviteTokenParam}`);
        setStudentData((prev) => ({ ...prev, inviteToken: inviteTokenParam }));
        setLinkStatus('valid');
      } catch (error) {
        setLinkStatus('invalid');
        setLinkError(error?.response?.data?.message || 'This application link is invalid.');
      }
    };
    validateInviteLink();
  }, [inviteTokenParam])

  // Steps 2–4: Education (1), References (2), Attachments (3) — open upload instruction modal when step loads
  useEffect(() => {
    if (activeStep === 1 || activeStep === 2 || activeStep === 3) {
      setInstructionModalOpen(true);
    }
  }, [activeStep]);

  // Gate the form behind the one-time link: nothing renders until it's confirmed valid.
  if (linkStatus !== 'valid') {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ width: 'auto', height: '100vh', backgroundColor: '#f5f5f5' }}>
        <Header />
        <Box sx={{ width: isMobile ? 'auto' : '50%', margin: "auto", mt: 12, backgroundColor: "white", padding: 4, borderRadius: 1, textAlign: "center" }}>
          {linkStatus === 'checking' ? (
            <Typography variant="h6">Checking your link…</Typography>
          ) : (
            <>
              <Typography variant="h5" fontWeight="bold" color="error" gutterBottom>Link unavailable</Typography>
              <Typography variant="body1">{linkError}</Typography>
            </>
          )}
        </Box>
      </Stack>
    );
  }

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ width: 'auto', height: '100vh', backgroundColor: '#f5f5f5' }}>
    <Header />
    <Box
      sx={{ width: isMobile ? 'auto' : '50%', margin: "auto", mt: 12, backgroundColor: "white", padding: 4, height: "80vh", overflow: "hidden", overflowY: "scroll"  }}
    >
    <CustomizedSnackbars ref={snackbar_Ref} />
    <DocumentInstructionModal
      pdfUrl={INSTRUCTIONS_PDF_URL}
      open={instructionModalOpen}
      onClose={() => setInstructionModalOpen(false)}
      title="Upload document instruction"
      newTabLabel="Open in new tab"
    />
    <Dialog open={lowGpaDialogOpen} onClose={() => setLowGpaDialogOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: "warning.main", fontWeight: 700 }}>Low GPA/CGPA warning</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ whiteSpace: "pre-line" }}>{LOW_GPA_WARNING_TEXT}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setLowGpaDialogOpen(false)}>Cancel</Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#4caf50", color: "white" }}
          onClick={() => {
            const updated = { ...studentData, acknowledgedLowGpa: true };
            setStudentData(updated);
            setLowGpaDialogOpen(false);
            submitEducationalDetail(updated);
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
    <Stepper
      activeStep={activeStep}
      connector={<StepConnector />}
      sx={{
        "& .MuiStepLabel-label": { fontSize: "1.2rem" },
        "& .MuiStepIcon-root": { fontSize: "2.5rem" },
        "& .Mui-active .MuiStepIcon-root": { color: "#4caf50" },
        "& .Mui-completed .MuiStepIcon-root": { color: "#4caf50" },
      }}
    >
      {[...Array(4)].map((_, index) => (
        <Step key={index}>
          <StepLabel />
        </Step>
      ))}
    </Stepper>
      <Grid item xs={10}>
        {activeStep === -1 ? (
          <Stack alignItems={'center'} justifyContent={'center'} >
            <h2>APPLY FOR MERITORIOUS SCHOLARSHIP - STUDENT</h2>
            <Desclaimer />
            <FormGroup>
              <FormControlLabel control={<Checkbox checked={isChecked} onChange={handleCheckBox} />} label=" By signing this document or submitting this application electronically, I acknowledge that I have read, understood, and agree to all the terms outlined in this disclosure." />
            </FormGroup>
             <ButtonMain
              variant="green"
              onClick={nextHandler}
            >
              Next
            </ButtonMain>
          </Stack>
              )
              : activeStep === -3 ? (
                <div className='d-flex flex-column align-items-center justify-content-center'>
                  <h2>STUDENT STATUS VERIFICATION</h2>
                  <p>Please select the appropriate option to indicate your current student status:</p>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox checked={isNewStudent} onChange={handleNewStudent} />} label="Are you a new Student?" />
                    <FormControlLabel control={<Checkbox checked={isReturningStudent} onChange={handleReturningStudent} />} label="Are you a returning Student?" />
                  </FormGroup>
                  {
                    isReturningStudent && (
                      <div className="col-md-12 d-flex justify-content-between">
                        <div className='text-field'>
                          <Typography className='text-field-label'>CNICNo</Typography>
                          <TextField
                            placeholder='00000-0000000-0'
                            value={studentData.CNICNo}
                            onChange={(e) => handleCNICNoChange(e.target.value)}
                          />
                        </div>
                      </div>

                    )
                  }
                  <ButtonMain
                    variant="green"
                    onClick={startFormHandler}
                  >
                    Start Form
                  </ButtonMain>
                </div>
              )
                : activeStep === 0 ?
                  (
                    <Stack alignItems={'center'} justifyContent={'center'}>
                      <h2>APPLY FOR MERITORIOUS SCHOLARSHIP - STUDENT</h2>
                      <Stack className="grid-2"  justifyContent={'space-between'}>
                        <Typography color="red">Personal Information</Typography>
                        <Typography color="red">All fields are required</Typography>
                          <TextField
                            required
                            label={"First Name"}
                            value={studentData.firstName}
                            onChange={(e) => { handleInputChange(e.target.value, "firstName", "text") }}
                          />
                            <TextField
                              required
                              label={"Last Name"}
                              value={studentData.lastName}
                              onChange={(e) => { handleInputChange(e.target.value, "lastName", "text") }}
                            />
                          <TextField
                            required
                            label="Preferred Email"
                            value={studentData.email}
                            onChange={(e) => handleInputChange(e.target.value, "email", "text")}
                          />
                          <Select
                            value={studentData.gender}
                            onChange={(e) => handleInputChange(e.target.value, "gender", "text")}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>
                              Select Gender
                            </MenuItem>
                            <MenuItem value="male">Male</MenuItem>
                            <MenuItem value="female">Female</MenuItem>
                            <MenuItem value="other">Other</MenuItem>
                          </Select>
                          <TextField
                            required
                            label="Country"
                              value={studentData.country}
                              onChange={(e) => { handleInputChange(e.target.value, "country", "text") }}
                            />
                            <TextField
                              required
                              label="City"
                              value={studentData.town}
                              onChange={(e) => { handleInputChange(e.target.value, "town", "text") }}
                            />
                            <TextField
                              required
                              label="Address"
                              value={studentData.address}
                              onChange={(e) => { handleInputChange(e.target.value, "address", "text") }}
                            />
                          <TextField
                            required
                            label="CNIC NO"
                            placeholder='00000-0000000-0'
                            value={studentData.CNICNo}
                            onChange={(e) => { handleCNICNoChange(e.target.value) }}
                          />
                            <Box display="flex" alignItems="center" sx={{ width: "100%"}}>
                              <Select
                                value={studentData.countryCode}
                                defaultValue="Pakistan"
                                onChange={(e) => handleInputChange(e.target.value, "countryCode", "text")}
                                displayEmpty
                                sx={{ width: "10%", minWidth: 100, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                              >
                                {countryCodes.map((country) => (
                                  <MenuItem key={country.label} value={country.label}>
                                    ({country.label ? country.label : "+92"})
                                  </MenuItem>
                                ))}
                              </Select>
                              <TextField
                                required
                                label="Phone Number (Mobile)"
                                type="number"
                                value={studentData.phoneNo_Mobile}
                                onChange={(e) => handleInputChange(e.target.value, "phoneNo_Mobile", "text")}
                                sx={{ width: "90%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                              />
                            </Box>
                            <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                              <Select
                                value={studentData.countryCode}
                                defaultValue="Pakistan"
                                onChange={(e) => handleInputChange(e.target.value, "countryCode", "text")}
                                displayEmpty
                                sx={{ width: "10%", minWidth: 100, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                              >
                                {countryCodes.map((country) => (
                                  <MenuItem key={country.label} value={country.label}>
                                    ({country.label ? country.label : "+92"})
                                  </MenuItem>
                                ))}
                              </Select>
                              <TextField
                                required
                                label="Phone Number (Home)"
                                type="number"
                                value={studentData.phoneNo_Home}
                                onChange={(e) => handleInputChange(e.target.value, "phoneNo_Home", "text")}
                                sx={{ width: "90%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                              />
                          </Box>
                          <TextField
                            required
                            label="Father Name"
                            value={studentData.fatherName}
                            onChange={(e) => { handleInputChange(e.target.value, "fatherName", "text") }}
                          />
                            <TextField
                              required
                              label="Mother Name"
                              value={studentData.motherName}
                              onChange={(e) => { handleInputChange(e.target.value, "motherName", "text") }}
                            />
                          <Select
                            value={studentData.orphan || ""}
                            onChange={(e) => handleInputChange(e.target.value, "orphan", "text")}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>
                              Orphan? (Yes/No)
                            </MenuItem>
                            <MenuItem value="yes">Yes</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                          </Select>
                          <TextField
                            required
                            label="Gross Household Income"
                            type='Number'
                            value={studentData.presentHouseholdIncome}
                            onChange={(e) => { handleInputChange(e.target.value, "presentHouseholdIncome", "number") }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Tooltip title="Please enter the total income of all earning members of the household, including the parent(s).">
                                    <InfoOutlined sx={{ fontSize: 18, color: 'rgba(0, 0, 0, 0.54)', cursor: 'help' }} />
                                  </Tooltip>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <TextField
                            required
                            label="Total Family Members"
                            type='Number'
                            value={studentData.totalFamilyMembers}
                            onChange={(e) => { handleInputChange(e.target.value, "totalFamilyMembers", "number") }}
                          />
                             <TextField
                                required
                                label="Password"
                                type={showPassword ? "text" : "password"}
                                value={studentData.password}
                                onChange={(e) => handleInputChange(e.target.value, "password")}
                                fullWidth
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              <TextField
                                required
                                label="Confirm Password"
                                type={showPassword ? "text" : "password"}
                                value={studentData.confirmPassword}
                                onChange={(e) => handleInputChange(e.target.value, "confirmPassword")}
                                fullWidth
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                />
                                <TextField
                                  required
                                  label="Signature (Full Name)"
                                  value={studentData.firstName + " " + studentData.lastName}
                                  onChange={(e) => { handleInputChange(e.target.value, "signature", "text") }}
                                  disabled={true}
                                />
                        </Stack>
                        <Stack sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          mt: 2,
                          gap: 2,
                          width: "100%",
                        }}>
                          <ButtonMain
                            variant="white"
                            onClick={previousHandler}
                          >
                            Back
                          </ButtonMain>

                          <ButtonMain
                            variant="green"
                            onClick={addPersonalDetailHandler}
                          >
                            Save and Continue
                          </ButtonMain>
                        </Stack>
                    </Stack>
                  )
                  : activeStep === 1 ?
                    (
                      <Stack alignItems={'center'} justifyContent={'center'} sx={{ height: '100%' }}>
                        <h2>APPLY FOR MERITORIOUS SCHOLARSHIP - EDUCATION</h2>
                        <Box
                          sx={{
                            width: '100%',
                            boxSizing: 'border-box',
                            backgroundColor: '#fff3f3',
                            border: '1px solid #ffcccc',
                            padding: '16px',
                            borderRadius: 2,
                            mb: 1,
                          }}
                        >
                          <Typography color="error" fontWeight={600}>
                            Please follow the instructions carefully:
                          </Typography>
                          <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
                            <li>
                              <Typography>
                                <Link
                                  component="button"
                                  type="button"
                                  onClick={() => setInstructionModalOpen(true)}
                                  sx={{ color: "error.main", cursor: "pointer", textDecoration: "underline" }}
                                >
                                  Upload document instruction
                                </Link>
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                All fields are required*
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                Last exam transcript, including SSC and HSC exams passed                                
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                Unpaid Fee Voucher                              
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                All documents must be scanned in <strong>PDF format</strong>. Pictures are not accepted.
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                Each file must not exceed <strong>1.5 MB</strong> in size.
                              </Typography>
                            </li>
                          </ul>
                        </Box>
                        <Stack className="grid-2"  justifyContent="space-between">
                            <TextField
                              required
                              label="Degree"
                              type="text"
                              value={studentData.degree}
                              onChange={(e) => { handleInputChange(e.target.value, "degree", "text") }}
                            />
                            <Autocomplete
                              options={facultyOptions}
                              value={studentData.faculty || null}
                              onChange={(event, newValue) => handleAutocompleteValue(newValue, "faculty")}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Choose Faculty"
                                  required
                                  variant="outlined"
                                />
                              )}
                            />
                            {studentData.faculty === "Other" && (
                              <TextField
                                label="Faculty Name"
                                value={studentData.otherFaculty}
                                onChange={(e) => handleInputChange(e.target.value, "otherFaculty")}
                              />
                            )}
                              <TextField
                                required
                                label="Semester"
                                type="number"
                                value={studentData.grade}
                                onChange={(e) => { handleInputChange(e.target.value, "grade", "number") }}
                              />
                              <TextField
                                required
                                label="Enrollment #"
                                type="text"
                                value={studentData.enrollmentNo}
                                onChange={(e) => { handleInputChange(e.target.value, "enrollmentNo", "text") }}
                              />
                              <Autocomplete
                                options={universities}
                                value={studentData.institutionName || null}
                                onChange={(event, newValue) => handleAutocompleteValue(newValue, 'institutionName')}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Institution Name"
                                    required
                                    variant="outlined"
                                  />
                                )}
                              />
                              {studentData.institutionName == "Other" && (
                                <TextField
                                  label="Institution Name"
                                  value={studentData.otherInstitutionName}
                                  onChange={(e) => { handleInputChange(e.target.value, "otherInstitutionName", "text") }}
                                />
                              )}
                            <TextField
                              required
                              label="Institution Address"
                              value={studentData.institutionAddress}
                              onChange={(e) => handleInputChange(e.target.value, "institutionAddress")}
                              variant="outlined"
                              fullWidth
                            />
                            <TextField
                              required
                              label="Tuition Fee"
                              type='Number'
                              value={studentData.tuttionFee}
                              onChange={(e) => { handleInputChange(e.target.value, "tuttionFee", "number") }}
                            />
                            <TextField
                              required
                              label="GPA/CGPA of previous semester"
                              type='number'
                              value={studentData.classOfLastInstitution}
                              onChange={(e) => { handleInputChange(e.target.value, "classOfLastInstitution", "number") }}
                            />
                              <FileUpload
                                ref={transcriptPhotoRef}
                                file={studentData.resultOfLastExamFile}
                                label="Transcript/Result of Last Exam"
                                onChange={(e) => handleFileChange(e, "resultOfLastExamFile")}
                                onClick={() => uploadPhotoHandler("transcriptPhotoRef")}
                                onRemove={() =>
                                  setStudentData((prev) => ({
                                    ...prev,
                                    resultOfLastExamFile: {
                                      fileName: "",
                                      url: "",
                                    },
                                  }))
                                }
                              />
                            <FileUpload
                              ref={voucherPhotoRef}
                              file={studentData.feeVoucherFile}
                              label="Unpaid Fee Voucher"
                              onChange={(e) => handleFileChange(e, "feeVoucherFile")}
                              onClick={() => uploadPhotoHandler("voucherPhotoRef")}
                              onRemove={() =>
                                setStudentData((prev) => ({
                                  ...prev,
                                  feeVoucherFile: {
                                    fileName: "",
                                    url: "",
                                  },
                                }))
                              }
                            />
                        </Stack>
                        <Stack sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            mt: 2,
                            gap: 2,
                            width: "100%",
                          }}>
                            <ButtonMain
                              variant="white"
                              onClick={previousHandler}
                            >
                              Back
                            </ButtonMain>
                            <ButtonMain
                              variant="green"
                              onClick={addEducationalDetailHandler}
                            >
                              Save and Continue
                            </ButtonMain>
                          </Stack>
                      </Stack>
                    )
                    : activeStep === 2 ?
                      (
                        <Stack alignItems={'center'} justifyContent={'center'} sx={{ height: '100%' }}>
                          <h2>APPLY FOR MERITORIOUS SCHOLARSHIP - REFERENCES</h2>
                           <Box
                          sx={{
                            width: '100%',
                            boxSizing: 'border-box',
                            backgroundColor: '#fff3f3',
                            border: '1px solid #ffcccc',
                            padding: '16px',
                            borderRadius: 2,
                            mb: 1,
                          }}
                        >
                          <Typography color="error" fontWeight={600}>
                            Please follow the instructions carefully:
                          </Typography>
                          <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
                          <li>
                            <Typography>
                              <Link
                                component="button"
                                type="button"
                                onClick={handleDownloadReferenceLetter}
                                sx={{ color: "error.main", cursor: "pointer", textDecoration: "underline" }}
                              >
                                Download Template Reference Letter(PDF)
                              </Link>
                            </Typography>
                          </li>
                            <li>
                              <Typography>
                                <Link
                                  component="button"
                                  type="button"
                                  onClick={() => setInstructionModalOpen(true)}
                                  sx={{ color: "error.main", cursor: "pointer", textDecoration: "underline" }}
                                >
                                  Upload document instruction
                                </Link>
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                All fields are required*
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                Two reference letters. The person referring should include his/her email and cell number                             
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                All documents must be scanned in <strong>PDF format</strong>. Pictures are not accepted.
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                Each file must not exceed <strong>1.5 MB</strong> in size.
                              </Typography>
                            </li>
                          </ul>
                        </Box>
                          <Stack className="grid-2" justifContent={'space-between'}>
                            <TextField
                              required
                              label="Reference 1 Name"
                              value={studentData.referenceName1}
                              onChange={(e) => { handleInputChange(e.target.value, "referenceName1", "text") }}
                            />
                            <TextField
                              required
                              label="Reference 1 Email"
                              value={studentData.referenceEmail1}
                              onChange={(e) => { handleInputChange(e.target.value, "referenceEmail1", "text") }}
                            />
                            <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                              <Select
                                value={studentData.countryCode}
                                defaultValue="Pakistan"
                                onChange={(e) => handleInputChange(e.target.value, "countryCode", "text")}
                                displayEmpty
                                sx={{ width: "10%", minWidth: 100, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                              >
                                {countryCodes.map((country) => (
                                  <MenuItem key={country.label} value={country.label}>
                                    ({country.label ? country.label : "+92"})
                                  </MenuItem>
                                ))}
                              </Select>
                              <TextField
                                required
                                label="Reference 1 Phone"
                                type="number"
                                value={studentData.referencePhone1}
                                onChange={(e) => handleInputChange(e.target.value, "referencePhone1", "text")}
                                sx={{ width: "90%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                              />
                            </Box>
                            <FileUpload
                              ref={referenceletterRef1}
                              file={studentData.referenceLetterFile1}
                              label="Reference Letter 1"
                              onChange={(e) => handleFileChange(e, "referenceLetterFile1")}
                              onClick={() => uploadPhotoHandler("referenceletterRef1")}
                              onRemove={() =>
                                setStudentData((prev) => ({
                                  ...prev,
                                  referenceLetterFile1: {
                                    fileName: "",
                                    url: "",
                                  },
                                }))
                              }
                            />
                            <TextField
                              required
                              label="Reference 2 Name"
                              value={studentData.referenceName2}
                              onChange={(e) => { handleInputChange(e.target.value, "referenceName2", "text") }}
                            />
                            <TextField
                              required
                              label="Reference 2 Email"
                              value={studentData.referenceEmail2}
                              onChange={(e) => { handleInputChange(e.target.value, "referenceEmail2", "text") }}
                            />
                            <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                              <Select
                                value={studentData.countryCode}
                                defaultValue="Pakistan"
                                onChange={(e) => handleInputChange(e.target.value, "countryCode", "text")}
                                displayEmpty
                                sx={{ width: "10%", minWidth: 100, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                              >
                                {countryCodes.map((country) => (
                                  <MenuItem key={country.label} value={country.label}>
                                    ({country.label ? country.label : "+92"})
                                  </MenuItem>
                                ))}
                              </Select>
                              <TextField
                                required
                                label="Reference 2 Phone"
                                type="number"
                                value={studentData.referencePhone2}
                                onChange={(e) => handleInputChange(e.target.value, "referencePhone2", "text")}
                                sx={{ width: "90%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                              />
                            </Box>
                            <FileUpload
                              ref={referenceletterRef2}
                              file={studentData.referenceLetterFile2}
                              label="Reference Letter 2"
                              onChange={(e) => handleFileChange(e, "referenceLetterFile2")}
                              onClick={() => uploadPhotoHandler("referenceletterRef2")}
                              onRemove={() =>
                                setStudentData((prev) => ({
                                  ...prev,
                                  referenceLetterFile2: {
                                    fileName: "",
                                    url: "",
                                  },
                                }))
                              }
                            />

                          </Stack>
                          <Stack sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            mt: 2,
                            gap: 2,
                            width: "100%",
                          }}>
                            <ButtonMain
                              variant="white"
                              onClick={previousHandler}
                            >
                              Back
                            </ButtonMain>

                            <ButtonMain
                              variant="green"
                              onClick={addReferenceDetailHandler}
                            >
                                Save and Continue
                            </ButtonMain>
                          </Stack>
                        </Stack>
                      )
                      : activeStep === 3 ?
                        (
                          <Stack alignItems={'center'} justifyContent={'center'} sx={{ height: '100%' }}>
                            <h2>AAPPLY FOR MERITORIOUS SCHOLARSHIP - ATTACHMENTS</h2>
                                        <Box
                          sx={{
                            width: '100%',
                            boxSizing: 'border-box',
                            backgroundColor: '#fff3f3',
                            border: '1px solid #ffcccc',
                            padding: '16px',
                            borderRadius: 2,
                            mb: 1,
                          }}
                        >
                          <Typography color="error" fontWeight={600}>
                            Please follow the instructions carefully:
                          </Typography>
                          <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
                            <li>
                              <Typography>
                                <Link
                                  component="button"
                                  type="button"
                                  onClick={() => setInstructionModalOpen(true)}
                                  sx={{ color: "error.main", cursor: "pointer", textDecoration: "underline" }}
                                >
                                  Upload document instruction
                                </Link>
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                All fields are required*
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                Recent electric bill of the residence                              
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                Proof of household income in Rupees per month
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                All documents must be scanned in <strong>PDF format</strong>. Pictures are not accepted.
                              </Typography>
                            </li>
                            <li>
                              <Typography color="error">
                                Each file must not exceed <strong>1.5 MB</strong> in size.
                              </Typography>
                            </li>
                          </ul>
                        </Box>
                            <Stack className="grid-2" justifyContent={'space-between'}>
                              <FileUpload
                                ref={studentCNICPhotoRef}
                                file={studentData.CNICFrontFile}
                                label="Student CNIC / B-Form (Front)"
                                onChange={(e) => handleFileChange(e, "CNICFrontFile")}
                                onClick={() => uploadPhotoHandler("studentCNICPhotoRef")}
                                onRemove={() =>
                                  setStudentData((prev) => ({
                                    ...prev,
                                    CNICFrontFile: {
                                      fileName: "",
                                      url: "",
                                    },
                                  }))
                                }
                              />
                              <FileUpload
                                ref={studentCNICBackPhotoRef}
                                file={studentData.CNICBackFile}
                                label="Student CNIC / B-Form (Back)"
                                onChange={(e) => handleFileChange(e, "CNICBackFile")}
                                onClick={() => uploadPhotoHandler("studentCNICBackPhotoRef")}
                                onRemove={() =>
                                  setStudentData((prev) => ({
                                    ...prev,
                                    CNICBackFile: {
                                      fileName: "",
                                      url: "",
                                    },
                                  }))
                                }
                              />
                              <FileUpload
                                ref={parentCNICPhotoRef}
                                file={studentData.parentCNICFrontFile}
                                label="Parents CNIC (Front)"
                                onChange={(e) => handleFileChange(e, "parentCNICFrontFile")}
                                onClick={() => uploadPhotoHandler("parentCNICPhotoRef")}
                                onRemove={() =>
                                  setStudentData((prev) => ({
                                    ...prev,
                                    parentCNICFrontFile: {
                                      fileName: "",
                                      url: "",
                                    },
                                  }))
                                }
                              />
                              <FileUpload
                                ref={parentCNICBackPhotoRef}
                                file={studentData.parentCNICBackFile}
                                label="Parents CNIC (Back)"
                                onChange={(e) => handleFileChange(e, "parentCNICBackFile")}
                                onClick={() => uploadPhotoHandler("parentCNICBackPhotoRef")}
                                onRemove={() =>
                                  setStudentData((prev) => ({
                                    ...prev,
                                    parentCNICBackFile: {
                                      fileName: "",
                                      url: "",
                                    },
                                  }))
                                }
                              />
                              <FileUpload
                                ref={proofOfIncomePicRef}
                                file={studentData.proofOfIncomeFile}
                                label="Proof of Income"
                                onChange={(e) => handleFileChange(e, "proofOfIncomeFile")}
                                onClick={() => uploadPhotoHandler("proofOfIncomePicRef")}
                                onRemove={() =>
                                  setStudentData((prev) => ({
                                    ...prev,
                                    proofOfIncomeFile: {
                                      fileName: "",
                                      url: "",
                                    },
                                  }))
                                }
                              />
                              <FileUpload
                                ref={currentBillPicRef}
                                file={studentData.currentElectricBillFile}
                                label="Current Electric Bill"
                                onChange={(e) => handleFileChange(e, "currentElectricBillFile")}
                                onClick={() => uploadPhotoHandler("currentBillPicRef")}
                                onRemove={() =>
                                  setStudentData((prev) => ({
                                    ...prev,
                                    currentElectricBillFile: {
                                      fileName: "",
                                      url: "",
                                    },
                                  }))
                                }
                              />
                              <FileUpload
                                ref={additionalDocsRef}
                                file={studentData.additionalDocs}
                                label="Matric and Intermediate Marksheet"
                                onChange={(e) => handleFileChange(e, "additionalDocs")}
                                onClick={() => uploadPhotoHandler("additionalDocsRef")}
                                onRemove={() =>
                                  setStudentData((prev) => ({
                                    ...prev,
                                    additionalDocs: {
                                      fileName: "",
                                      url: "",
                                    },
                                  }))
                                }
                              />
                              <FileUpload
                                ref={otherDocumentsRef}
                                file={studentData.otherDocumentsFile}
                                label="Other Documents (Optional)"
                                onChange={(e) => handleFileChange(e, "otherDocumentsFile")}
                                onClick={() => uploadPhotoHandler("otherDocumentsRef")}
                                onRemove={() =>
                                  setStudentData((prev) => ({
                                    ...prev,
                                    otherDocumentsFile: {
                                      fileName: "",
                                      url: "",
                                    },
                                  }))
                                }
                              />
                            </Stack>
                            <Stack sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "flex-end",
                              mt: 2,
                              gap: 2,
                              width: "100%",
                            }}>
                              <ButtonMain
                                variant="white"
                                onClick={previousHandler}
                              >
                                Back
                              </ButtonMain>
                              <ButtonMain
                                variant="green"
                                onClick={addAttachmentDetailHandler}
                              >
                                Submit
                              </ButtonMain>
                            </Stack>
                          </Stack>
                        )
                        :
                        activeStep === 4 ?
                          (
                            <Stack alignItems={'center'} justifyContent={'space-between'} sx={{ height: '76%' }} >
                              {/* <Stack alignItems={'center'} justifyContent={'space-between'}sx={{height:'80%',border:'2px solid red'}} > */}
                              <h2>You are All Set!</h2>
                              <Typography>Your application is under review. [insert more informational text].  </Typography>
                              <Typography>Sign in to view your application status</Typography>
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: "#208146",
                                  color: 'white',
                                  width: '92px',
                                  height: "5vh",
                                  fontSize: '12px',
                                  borderRadius: '12px',
                                  "&:hover": {
                                    backgroundColor: "#208146",
                                  },
                                }}
                                onClick={() => { navigate("/") }}
                              >
                                Sign In
                              </Button>
                            </Stack>
                          ) : null}
                          </Grid>
                      </Box>
                      </Stack>
                    );
}

export default ScholarshipForm